import { create } from "zustand";
import { apiRequest } from "../utils/api";

const useMailStore = create((set, get) => {
  const fetchUnreadTotal = async () => {
    try {
      const access = localStorage.getItem("access");
      const refresh = localStorage.getItem("refresh");

      // トークンが両方ないなら通信しない
      if (!access && !refresh) {
        set({ unreadTotal: 0 });
        return;
      }

      const res = await apiRequest("inventory/mail/folder_stats/");

      const total = Object.entries(res).reduce((sum, [key, val]) => {
        if (key !== "sent" && key !== "trash") {
          return sum + (val?.unread || 0);
        }
        return sum;
      }, 0);

      set({ unreadTotal: total });
    } catch (error) {
      // api.js の未ログイン中止は静かに無視
      if (error?.skipRequest) {
        set({ unreadTotal: 0 });
        return;
      }

      // 401系も未読0にして終わる
      if (error?.status === 401) {
        set({ unreadTotal: 0 });
        return;
      }

      console.error("📧 未読数取得エラー", error);
    }
  };

  return {
    unreadTotal: 0,
    fetchUnreadTotal,
  };
});

export default useMailStore;